var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "transition",
        { attrs: { name: _vm.mainName } },
        [
          _vm.$route.meta.keepAlive
            ? _c(
                "keep-alive",
                [
                  _vm.$route.meta.keepAlive
                    ? _c("router-view", { attrs: { id: "view" } })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          !_vm.$route.meta.keepAlive && _vm.isRouterAlive
            ? _c("router-view", { attrs: { id: "view" } })
            : _vm._e(),
        ],
        1
      ),
      _vm.isShowNav ? _c("app-tab-bar") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }